var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',{attrs:{"with_go_back_bar":""}},[(_vm.constants && _vm.form_data)?_c('register-pos-form',{attrs:{"form_data":_vm.form_data,"wizard":_vm.wizard}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }